"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrNameWrapper = exports.FdrSubmitButtonWrapper = exports.FdrEmailNewsletterForm = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_privacy_1 = require("@hotelplan/components.common.privacy");
exports.FdrEmailNewsletterForm = styled_components_1.default.form(({ theme }) => theme.forms.emailForm);
exports.FdrSubmitButtonWrapper = (0, styled_components_1.default)(components_common_privacy_1.SubmitWithPrivacyButtonWrapper)(({ theme }) => theme.forms.emailForm.submitButtonWrapper);
exports.FdrNameWrapper = styled_components_1.default.div(({ theme }) => theme.forms.fullNameWrapper);
//# sourceMappingURL=fdr-newsletter-form.styles.js.map